export default function SectionCard({ title, subtitle, children, actions, className = "", testid }) {
  return (
    <section
      data-testid={testid}
      className={`rounded-2xl border border-slate-200 bg-white shadow-sm p-6 ${className}`}
    >
      {(title || actions) && (
        <div className="flex items-start justify-between mb-4 gap-4">
          <div>
            {title && <h3 className="text-lg font-semibold text-slate-900 tracking-tight">{title}</h3>}
            {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
          </div>
          {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}
